<template>
  <UiEternalLoading
    v-if="!disableScrollTop"
    :handler="scrollTopHandler"
    :all-loaded="disableScrollTop"
  />
  <slot />
  <UiEternalLoading
    v-if="!disableScrollBottom"
    :handler="scrollDownHandler"
    :all-loaded="disableScrollBottom"
  />
</template>

<script lang="ts" setup>
import UiEternalLoading from './UiEternalLoading.vue'

defineProps<{
  scrollTopHandler: (() => Promise<void>) | (() => void)
  scrollDownHandler: (() => Promise<void>) | (() => void)
  disableScrollTop: boolean
  disableScrollBottom: boolean
}>()
</script>
